import axios from "axios";

let WPQ_API_URL
let MASTER_API_URL

if (process.env.REACT_APP_NODE_ENV === "local") {
  WPQ_API_URL = process.env.REACT_APP_WPQ_GROOVE_API_URL;
  MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
} else {
  WPQ_API_URL = process.env.REACT_APP_API_URL + "wpq";
  MASTER_API_URL = process.env.REACT_APP_API_URL + "masters";
}

export async function getAllWpqByWelder(welderId) {
  const url = WPQ_API_URL + "/WpqHeaderMast/checkWelderWPQ"
  const response = await axios.post(url, welderId).then(function (resp) {
    return resp;
  })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function deleteWelder(welderId) {
  const url = MASTER_API_URL + "/Welder/delete";
  const response = await axios.post(url, welderId)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
}

export async function getAllWelder() {
  const response = await axios.get(MASTER_API_URL + "/Welder/get")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function getActiveWelder() {
  const response = await axios
    .get(MASTER_API_URL + "/welder/active")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}



export const AddNewWelder = async (Welder) => {
  let url = `${MASTER_API_URL}/Welder`;
  const response = await axios
    .post(url, Welder)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};


export const UpdateWelder = async (Welder) => {
  let url = `${MASTER_API_URL}/Welder/update`;
  const response = await axios
    .post(url, Welder)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};
export const getPresignedURLForTrainingRecord = async (subjectMonth, salaryCode, filename) => {
  // Backend route: /images/wld_Images/TrainingRecord/:subjectMonth/:salaryCode/:filename
  const url = `${MASTER_API_URL}/file/images/wld_Images/TrainingRecord/${subjectMonth}/${salaryCode}/${encodeURIComponent(filename)}`;

  try {
    const resp = await axios.get(url);
    return resp.data; // expect { url: "<signed-url>", key: "<s3-key>" }
  } catch (error) {
    return { message: "Unable to get presigned URL", status: false };
  }
};

export const getPresignedURLForPQRRecord = async (wld_WPSType, PQRNo, filename) => {
  // Backend route: /images/wld_Images/PQR/:wld_WPSType/:PQRNo/:filename
  const url = `${MASTER_API_URL}/file/images/wld_Images/PQR/${wld_WPSType}/${PQRNo}/${encodeURIComponent(filename)}`;

  try {
    const resp = await axios.get(url);
    return resp.data; // expect { url: "<signed-url>", key: "<s3-key>" }
  } catch (error) {
    return { message: "Unable to get presigned URL", status: false };
  }
};



export const getPresignedURL = async (folderName, wld_profile) => {
  let url = `${MASTER_API_URL}/file/images/wld_Images/${folderName}/${wld_profile}`;
  const response = await axios.get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const getPresignedURLWeldRepair = async (folderName, wld_profile) => {
  let url = `${MASTER_API_URL}/file/images/wld_Images/weldrepair/${folderName}/${wld_profile}`;
  const response = await axios.get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const getPresignedURLDev = async (folderName, subfolder, wld_profile) => {
  let url = `${MASTER_API_URL}/file/images/wld_Images/${folderName}/${subfolder}/${wld_profile}`;
  const response = await axios.get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/* export async function DeleteWelder(Welder) {
  let url = `${MASTER_API_URL}/Welder/delete`;
  const resp = await axios
    .post(url, Welder)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
} */

/* export async function getRequiredActiveWelder() {
  const response = await axios
    .get(MASTER_API_URL + "/welder/reqActive")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}
 */
//download file from s3
export async function downloadAttachment(downloadObj) {
  let url = `${MASTER_API_URL}/file/downloadFile/${downloadObj.foldername}/${downloadObj.filename}`;
  const response = await axios
    .get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to fetch File", status: false };
    });
  let preSignedUrl = response.data;
  const link = document.createElement("a");
  link.setAttribute("href", preSignedUrl);
  link.setAttribute("download", downloadObj.filename);
  link.click();
  link.remove();
}

export async function getWelderById(wldObj) {
  const response = await axios
    .post(MASTER_API_URL + "/welder/getWelderById", wldObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function deleteWPQFile(filepath, filename) {
  const url = `${MASTER_API_URL}/file/wpq/deletefile`;
  const response = await axios
    .post(url, { filepath, filename })
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to delete file", status: false };
    });
  return response.data;
};